import { FC } from "react";
import { Building2 } from "lucide-react";

export const NoOrganizationState: FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <Building2 className="w-16 h-16 text-slate-500 mb-4" />
      <h2 className="text-xl font-semibold text-slate-200 mb-2">
        No organization
      </h2>
      <p className="text-slate-400 max-w-md">
        You are not a member of any organization. Contact your administrator to
        get invited.
      </p>
    </div>
  );
};
